import { useEffect } from 'react'
import MotifMap from '../../components/MotifMap'
import { useContextMotifDetails } from '../../contexts/motifDetailsContext'
import { UIElement } from '../../types/UIElements'
import { useContextPanels } from '../../contexts/panelsContext'
import { useContextOnboarding } from '../../contexts/onboardingContext'
import FirstVisitNotification from '../../components/FirstVisitNotification'

interface Props {
  canShowMotifMap?: boolean
}

const Home = ({ canShowMotifMap = true }: Props) => {
  const { setDetailsOpen } = useContextMotifDetails()
  const { isPanelOpen, closeAll } = useContextPanels()
  const { isAnimationShowing } = useContextOnboarding()

  useEffect(() => {
    if (isPanelOpen(UIElement.QRMODAL)) {
      closeAll()
    }

    return () => {
      setDetailsOpen(false)
      closeAll()
    }
  }, [])

  return (
    <>
      {isAnimationShowing ? (
        <FirstVisitNotification isAnimationShowing={isAnimationShowing} />
      ) : null}
      <MotifMap canDraw={canShowMotifMap} />
    </>
  )
}

export default Home
